import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import helpers from './mixins/helpers'

import vuetify from './plugins/vuetify'
import './plugins'

import octaviaKit from '@/plugins/octavia.kit'

import firebase from 'firebase/compat/app'
import { getFunctions } from "firebase/functions";

import VueApexCharts from 'vue-apexcharts'
import VueJsonToCsv from 'vue-json-to-csv'
import SequentialEntrance from 'vue-sequential-entrance'
import 'vue-sequential-entrance/vue-sequential-entrance.css'
import 'firebase/compat/auth';

Vue.component('content-page', () => import('@/components/ContentPage.vue'))
Vue.component('apexchart', VueApexCharts)

Vue.use(VueJsonToCsv)
Vue.use(octaviaKit)
Vue.mixin(helpers)

Vue.use(SequentialEntrance);
Vue.config.productionTip = true

Vue.prototype.$appName = 'Paythings'
Vue.prototype.$appProd = false

// if (process.env.NODE_ENV === "development") {
//   makeServer();
// }
// const firebaseConfig = {
//   apiKey: "AIzaSyALRi1x2kCgIBJ3VjvtQFVTSb_Q88MOWzk",
//   authDomain: "pt-dev-system.firebaseapp.com",
//   databaseURL: "https://pt-dev-system-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "pt-dev-system",
//   storageBucket: "pt-dev-system.appspot.com",
//   messagingSenderId: "183259799222",
//   appId: "1:183259799222:web:ee552ec7eae949ef3ad017"
// }
const firebaseConfig = {
  apiKey: 'AIzaSyAqxmU_QmI_HKHhA05QqV6IktBx3x77qNo',
  authDomain: 'e2cdata.firebaseio.com',
  databaseURL: 'https://e2cdata.firebaseio.com',
  storageBucket: 'e2cdata.appspot.com',
  projectId: 'e2cdata'
}

// Initialize Firebase
let fbapp = firebase.initializeApp(firebaseConfig)
const fbfunctions = getFunctions(fbapp);

new Vue({
  store,
  router,
  vuetify,
  beforeCreate () {
    this.$store.dispatch('loadUserInstitutions')

    // firebase.auth().onAuthStateChanged((user) => {
    //   if (user) {
    //     console.log('we have an auto user ', user)
    //     // this.$store.dispatch('autoSignIn', user)
    //     //   .then(() => {
    //     //     // we should wait till this comes back to us and only load thier data
    //     //     // this.$store.dispatch('loadUserInstitutions')
    //     //     // this.$store.dispatch('loadunits')
    //     //     // this.$store.dispatch('loadsiteProfiles')
    //     //     // this.$store.dispatch('loadUserGroups')
    //     //     // this.$store.dispatch('loadSiteConfigs')
    //     //     // this.$store.dispatch('loadheartbeats')
    //     //     }
    //     //   )
    //     //   .catch(err => {
    //     //     console.log(err)
    //     //   })
    //   }
    // })
  },
  render: (h) => h(App),
}).$mount('#app')
